import VueRouter from 'vue-router'

//import configurationComponent from './components/configuration/configuration.vue'
//import mainElementGridComponent from './components/mainElement/mainElementGrid.vue'

import testComponent from './components/test.vue'
import userComponent from './components/user/user.vue'
import languageMarketComponent from './components/languageMarket/languageMarket.vue'
import configuratorsComponent from './components/configurator/configurators.vue'
import productFamiliesComponent from './components/family/productFamilies.vue'
import mainElementsComponent from './components/mainElement/mainElements.vue'
import resultsComponent from './components/results/results.vue'
import notFoundComponent from './components/notFound.vue'
import myConfigsComponent from './components/configManagement/myConfigs.vue'
import accessDeniedComponent from './components/accessDenied.vue'
import mustLoginComponent from './components/mustLogin.vue'

import { app } from "./application.js";

//FALTA TODO, traduir per dif idiomes

//const DEFAULT_TITLE = 'UNEX | Configurator';
const DEFAULT_TITLE = app.translate("browser_title_default");

const router = new VueRouter({
	mode: 'hash',
	/* base: __dirname, */

	/*

	country: es, en, de, es-cl, es-mx, fr, it, nl, pl, pt, ru
	language: Español, Français, Português, Русский, Mexicano, Polski, Nederlands, Italiano, Deutsch, Chileno
	?languague=es&market=spain

	*/

	routes: [
		{
			path: '/', name: 'home', component: languageMarketComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(0, next, to);
			}
		},

		{
			path: '/0', name: 'language_market', component: languageMarketComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(0, next, to);
			}
		},

		{
			path: '/language', name: 'language_market_review', component: languageMarketComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage('language', next, to);
			}
		},
		{
			path: '/1', name: 'configurator',
			component: configuratorsComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(1, next, to);
			}
		},
		{
			path: '/2', name: 'family', component: productFamiliesComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(2, next, to);
			}
		},
		{
			path: '/3',
			name: 'mainElement',
			component: mainElementsComponent,
			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(3, next, to);
			}
		},

		{
			path: '/4', name: 'results', component: resultsComponent,

			beforeEnter: async (to, from, next) => {
				app.showNavigationBar = true;
				await app.beforeEnterStage(4, next, to);
			}
		},

		{
			path: '/myConfigs', name: 'myConfigs', component: myConfigsComponent,
			beforeEnter: (to, from, next) => {

				app.showNavigationBar = true;
                app.trackEvent("my_configs")

				next();

			}
		},

		{
			path: '/accessDenied', name: 'accessDenied', component: accessDeniedComponent,
			beforeEnter: (to, from, next) => {
				app.showNavigationBar = false;
				next();
			}
		},

		{
			path: '/mustLogin', name: 'mustLogin', component: mustLoginComponent,
			beforeEnter: (to, from, next) => {
                // If logged in:
                if( app.auth.isLogged ){
                    next('1');
                }else{
                    app.showNavigationBar = false;
                    next();
                }
			}
		},
		{
			path: '/user', name: 'user', component: userComponent,
			beforeEnter: (to, from, next) => {
				app.showNavigationBar = false;
				next();
			}
		},

		{
			path: '/l/:lang/:market', name: '1_from_web',
			component: languageMarketComponent,
			beforeEnter: (to, from, next) => {
				app.showNavigationBar = false;
				next();
			}
		},

		{ path: '/test', name: 'test', component: testComponent },

		{
			path: '*', name: 'otherUrls', component: notFoundComponent,
			beforeEnter: (to, from, next) => {
				app.showNavigationBar = false;
				next();
			}
		}

	],

	//scroll to top of all route navigations
	//scrollBehavior(to, from, savedPosition) { return { x: 0, y: 0 } }
})


router.afterEach((to, from) => {
	// document.title = to.meta.title || DEFAULT_TITLE;
	app.trackScreenView(to.name);
});

export { router };
